var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-self-selection__results",style:(_vm.style)},[_vm._l((_vm.allResults),function(result){return [(_vm.isCurrent(result))?_c('call-to-action',{key:result.key,attrs:{"html":result.html}}):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }